import CanvasLightTheme from 'foundations-theming-base/stable/canvas/light/theme';
import { getCssVariablesTheme } from './utils/localCssVariables';

// The theme used here is the one which will be used for fallback values if variables are not present
// as such, make sure this is always pointing to the "default" theme.
export default getCssVariablesTheme(CanvasLightTheme);